// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-height-collision-targets[data-v-b0e8a170]{max-height:80px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
